<template>
  <div class="quantity-selector">
    <span v-show="!isMinusDisabled" @click="decreaseQuantity" aria-label="Decrease Quantity"
      ><i class="af af-minus" :class="{ disabled: isMinusDisabled }"></i
    ></span>
    <input readonly class="qty-input" type="text" v-model="quantity" />
    <span v-show="!isPlusDisabled" @click="increaseQuantity" aria-label="Increase Quantity"
      ><i class="af af-plus" :class="{ disabled: isPlusDisabled }"></i
    ></span>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
export default {
  name: 'QuantitySelector',
  props: {
    packagedItemQuantity: {
      type: Number,
      default: 1,
    },
  },

  setup(props, { emit }) {
    const quantity = ref(props.packagedItemQuantity);
    const minQuantity = props.packagedItemQuantity * 1;
    const maxQuantity = props.packagedItemQuantity * 99;

    const increaseQuantity = () => {
      if (quantity.value + props.packagedItemQuantity <= maxQuantity) {
        quantity.value += props.packagedItemQuantity;
        emit('onQuantityChange', quantity.value);
      }
    };

    const decreaseQuantity = () => {
      if (quantity.value - props.packagedItemQuantity >= minQuantity) {
        quantity.value -= props.packagedItemQuantity;
        emit('onQuantityChange', quantity.value);
      }
    };

    const isPlusDisabled = computed(() => quantity.value >= maxQuantity);
    const isMinusDisabled = computed(() => quantity.value <= minQuantity);
    return {
      quantity,
      increaseQuantity,
      decreaseQuantity,
      isPlusDisabled,
      isMinusDisabled,
    };
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';
.quantity-selector {
  height: 38px;
  width: 108px;
  position: relative;
  padding-right: 16px;
  box-shadow: none;

  &:hover {
    box-shadow: none;
    transition: none;
  }
  span {
    cursor: pointer;
    height: 16px;
    width: 14px;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .qty-input {
    border-radius: 30px;
    border-color: var(--grey-ultra-dark);
    border-width: 1px;
    padding: 4px, 11px, 4px, 11px;
    text-align: center;
    display: inline-block;
    box-shadow: none;
    font-weight: 700;

    &:hover,
    &:focus {
      border-color: var(--grey-ultra-dark) !important;
      box-shadow: none !important;
      transition: none !important;
    }
  }

  .af {
    font-size: var(--font-size-16);
    font-weight: 300;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: center;
    color: (--grey-ultra-dark);
    &:hover {
      color: var(--grey-ultra-dark);
    }
  }

  .af-plus {
    position: absolute;
    left: 60px;
    top: 11px;
    text-align: center;
    &::before {
      padding: 12px 18px 12px 14px;
    }
  }
  .af-minus {
    position: absolute;
    top: 11px;
    &::before {
      padding: 12px 14px 12px 18px;
    }
  }
}
</style>
